import { useContext, useEffect } from 'react'
import { shallowEqual, useAppSelector } from 'hooks/reduxHooks'
import useOfferPageDispatch from './useOfferPageDispatch'
import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { getDefaultMultipleRoomPackages } from 'selectors/offerPage/multipleRoomBookingSelectors'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'

/**
 * This hook is used to select the default multiple room packages when the offer page is loaded.
 */
function useDefaultMultipleRoomPackages() {
  const stateDispatch = useOfferPageDispatch()

  const offerPageState = useContext(OfferPageStateContext)
  const defaultMultipleRoomPackages = useAppSelector((state: App.State) => getDefaultMultipleRoomPackages(offerPageState, state), shallowEqual)
  const rooms = offerPageState.rooms ?? []

  useEffect(() => {
    if (defaultMultipleRoomPackages.length) {
      const roomsPackages = defaultMultipleRoomPackages
        .filter(multipleRoomPackage => rooms.some(room => room.roomId === multipleRoomPackage.roomId))
        .map(multipleRoomPackage => ({
          room: rooms.find(room => room.roomId === multipleRoomPackage.roomId)!,
          packageOption: multipleRoomPackage.view.package,
        }))
      stateDispatch({
        type: OfferPageActions.selectRoomsPackages,
        roomsPackages,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultMultipleRoomPackages])
}

export default useDefaultMultipleRoomPackages
